<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close" size="lg">
            <!-- Body -->
            <template #body>
                <vs-tabs>
                    <vs-tab :label="file.name" v-for="(file, index) in files" :key="index">
                        <div >
                             <iframe v-if="file.src" :src="file.src" width="100%" height="600px" style="border:none;" />
                        </div>
                    </vs-tab>
                </vs-tabs>
            </template>

        </base-modal>
    </div>
</template>

<script setup>
import BaseModal from '@/views/app/components/BaseModal.vue'

const emit = defineEmits(['close'])

const props = defineProps({
    value: { type: Boolean, default: false },
    files: { type: Array, default: () => ([]) },
    title: { type: String, default: 'title'}

})

const close = () => {
    emit('input', false)
}

</script>
